import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const CompetitiveExamMasterName = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        examName: "",
        authority: "",
        authorityName: "",
        subjectMasterId: '',
        gradeMasterId: []
    }
    const [formData, setFormData] = useState([])
    const [compatitiveExamData, setCompatitiveExamData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNewExamName, setAddNewExamName] = useState(false);

    const [authoritySort, setAuthoritySort] = useState(null);
    const [authorityNameSort, setAuthorityNameSort] = useState(null);
    const [examNameSort, setExamNameSort] = useState(null);
    const [gradeNameSort, setGradeNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["authorityName", "examName", "competitiveExamNameMasterDetails.gradeMasterDetails.gradeName", "competitiveExamNameMasterSubjectDetails.subjectMasterDetails.subjectName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);

            let apiUrl = '/get-competitive-exam-name-master?';

            if (compatitiveExamData.subjectMasterId) {
                apiUrl += `subjectIds=${compatitiveExamData.subjectMasterId}&`;
            }

            if (compatitiveExamData.gradeMasterId) {
                apiUrl += `gradeIds=${compatitiveExamData.gradeMasterId}&`;
            }

            if (compatitiveExamData.authority) {
                apiUrl += `authority=${compatitiveExamData.authority}&`;
            }

            if (compatitiveExamData.examName) {
                apiUrl += `examName=${compatitiveExamData.examName}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            setSyllabusList(await searchArray("A", apiUrl, searchKeys, searchValue.trim(), "data"))
        }
    }

    useEffect(() => {
        let apiUrl = '/get-competitive-exam-name-master?';

        if (compatitiveExamData.subjectMasterId) {
            apiUrl += `subjectIds=${compatitiveExamData.subjectMasterId}&`;
        }

        if (compatitiveExamData.gradeMasterId) {
            apiUrl += `gradeIds=${compatitiveExamData.gradeMasterId}&`;
        }

        if (compatitiveExamData.authority) {
            apiUrl += `authority=${compatitiveExamData.authority}&`;
        }

        if (compatitiveExamData.examName) {
            apiUrl += `examName=${compatitiveExamData.examName}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSyllabusList(response.data.data);
            })
            .catch(error => {
                setSyllabusList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [compatitiveExamData, refresh]);

    const getExamNameList = () => {
        let apiUrl = '/get-competitive-exam-name-master?';

        if (compatitiveExamData.subjectMasterId) {
            apiUrl += `subjectIds=${compatitiveExamData.subjectMasterId}&`;
        }

        if (compatitiveExamData.gradeMasterId) {
            apiUrl += `gradeIds=${compatitiveExamData.gradeMasterId}&`;
        }

        if (compatitiveExamData.authority) {
            apiUrl += `authority=${compatitiveExamData.authority}&`;
        }

        if (compatitiveExamData.examName) {
            apiUrl += `examName=${compatitiveExamData.examName}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSyllabusList(response.data.data);
                setAddNewExamName(!addNewExamName);
            })
            .catch(error => {
                setSyllabusList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log("Error fetching data: ", errorMsg)
            });
    }

    const handleInputChange = (e, index) => {
        setCompatitiveExamData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else if (e.target.name === "examName" || e.target.name === "authorityName") {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value.toUpperCase(),
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        })
    }

    const handleChangeClass = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setCompatitiveExamData((prevData) => {
            return {
                ...prevData,
                gradeMasterId: selectedIds,
            }
        })

    }

    const handleChangeSub = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setCompatitiveExamData((prevData) => {
            return {
                ...prevData,
                subjectMasterId: selectedIds,
            }
        })
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewExamName])

    useEffect(() => {
        setTotalPages(Math.ceil(syllabusList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > syllabusList.length) {
            endIndex = syllabusList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(syllabusList.slice(startIndex, endIndex));
    }, [syllabusList, currPage, itemsPerPage]);

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(compatitiveExamData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(compatitiveExamData)) {
                if (compatitiveExamData[key] == '' || compatitiveExamData[key].length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [compatitiveExamData])

    const addSyllabusType = () => {
        const apiUrl = `/add-competitive-exam-name-master`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, compatitiveExamData)
                .then(response => {
                    getExamNameList();
                    setCompatitiveExamData((prevData) => {
                        return {
                            ...prevData,
                            authorityName: [''],
                        }
                    })

                    setSaveId(response.data.result.id);
                    setAuthoritySort(null);
                    setAuthorityNameSort(null);
                    setExamNameSort(null);
                    setGradeNameSort(null);
                    setSubjectNameSort(null);
                    setSearchValue(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(compatitiveExamData)) {
                if (value == '' || value.length !== 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSyllabus = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-competitive-exam-name-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSyllabus = () => {
        setLoading(true);
        const apiUrl = `/edit-competitive-exam-name-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, compatitiveExamData)
            .then(response => {
                setEditId(null);
                setCompatitiveExamData((prevData) => {
                    return {
                        ...prevData,
                        syllabusStructureName: [''],
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleReset = () => {
        setEditId('');
        setCompatitiveExamData(initialFormState);
        setAuthoritySort(null);
        setAuthorityNameSort(null);
        setExamNameSort(null);
        setGradeNameSort(null);
        setSubjectNameSort(null);
        setSearchValue(null);
        setError(initialErrorState);
    }

    const SubList = formData?.subjectData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.subjectName
        }
    }) || [];

    const GradeList = formData?.gradeData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.gradeName
        }
    }) || [];

    useEffect(() => {
        if (authoritySort == true || authoritySort == false) {
            setAuthorityNameSort(null);
            setExamNameSort(null);
            setGradeNameSort(null);
            setSubjectNameSort(null);
        }
    }, [authoritySort])

    useEffect(() => {
        if (authorityNameSort == true || authorityNameSort == false) {
            setAuthoritySort(null);
            setExamNameSort(null);
            setGradeNameSort(null);
            setSubjectNameSort(null);
        }
    }, [authorityNameSort])

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setAuthoritySort(null);
            setAuthorityNameSort(null);
            setGradeNameSort(null);
            setSubjectNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (gradeNameSort == true || gradeNameSort == false) {
            setAuthoritySort(null);
            setAuthorityNameSort(null);
            setExamNameSort(null);
            setSubjectNameSort(null);
        }
    }, [gradeNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setAuthoritySort(null);
            setAuthorityNameSort(null);
            setExamNameSort(null);
            setGradeNameSort(null);
        }
    }, [subjectNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Name</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-clipboard-list"></i>Competitive Exam Name </b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={GradeList.filter(option =>
                                                            compatitiveExamData.gradeMasterId && compatitiveExamData.gradeMasterId.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="gradeMasterId"
                                                        options={GradeList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeClass}
                                                    />
                                                    {error.gradeMasterId && <p style={{ color: 'red' }}>{error.gradeMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject:</label>
                                                    <Select
                                                        value={SubList.filter(option =>
                                                            compatitiveExamData.subjectMasterId && compatitiveExamData.subjectMasterId.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="subjectMasterId"
                                                        options={SubList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeSub}
                                                    />
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name :</label>
                                                    <input type="text" className="form-control" id={`examName`} name='examName' onChange={handleInputChange} value={compatitiveExamData.examName} />
                                                    {error.examName && <p style={{ color: 'red' }}>{error.examName}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="authority" className="col-form-label"><span style={{ color: "red" }}>*</span>Authority :</label>
                                                    <select class="form-select" aria-label="Default select example" name='authority' onChange={handleInputChange} value={compatitiveExamData.authority}>
                                                        <option selected value={''} disabled>Select Authority</option>
                                                        <option value={'govt'} >Government</option>
                                                        <option value={'pvt'} >Private</option>
                                                    </select>
                                                    {error.authority && <p style={{ color: 'red' }}>{error.authority}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="authorityName" className="col-form-label"><span style={{ color: "red" }}>*</span>Authority Name :</label>
                                                    <input type="text" className="form-control" id={`authorityName`} name='authorityName' onChange={handleInputChange} value={compatitiveExamData.authorityName} />
                                                    {error.authorityName && <p style={{ color: 'red' }}>{error.authorityName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addSyllabusType}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon delete_icon" type="button" onClick={handleReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSyllabus} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Authority
                                                                            <SortIcon sortState={authoritySort} setSortState={setAuthoritySort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"authority"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Authority Name
                                                                            <SortIcon sortState={authorityNameSort} setSortState={setAuthorityNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"authorityName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Class
                                                                            <SortIcon sortState={gradeNameSort} setSortState={setGradeNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.gradeMasterDetails.gradeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterSubjectDetails.subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((syllabus, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{syllabus.authority === "pvt" ? "Private" : syllabus.authority === "govt" ? "Government" : ""}</td>
                                                                                        <td>{syllabus.authorityName}</td>
                                                                                        <td>{syllabus.examName}</td>
                                                                                        <td>{syllabus?.competitiveExamNameMasterDetails?.map((i) => i.gradeMasterDetails.gradeName).join(', ')}</td>
                                                                                        <td>{syllabus?.competitiveExamNameMasterSubjectDetails?.map((i) => i.subjectMasterDetails.subjectName).join(', ')}</td>
                                                                                        <td>
                                                                                            <button disabled className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setCompatitiveExamData({
                                                                                                    authority: syllabus.authority,
                                                                                                    authorityName: syllabus.authorityName,
                                                                                                    examName: syllabus.examName,
                                                                                                    gradeMasterId: [syllabus.gradeMasterDetails.id.toString()],
                                                                                                    subjectMasterId: syllabus.subjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(syllabus.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === syllabus.id} onClick={() => deleteSyllabus(syllabus.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: "50px" }}>No Competitive Exam Name Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={syllabusList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CompetitiveExamMasterName;